import { createSignal, Show } from 'solid-js'
import { Button } from '@ui/components/Button'
import { Input } from '@ui/components/Input'
import type { UsuarioPublico } from '@shared/types'
import { api } from '../nucleo/cliente'
import { mensagemErro } from '../lib/erro'

export function Login(props: { aoEntrar: (u: UsuarioPublico) => void }) {
  const [login, setLogin] = createSignal('')
  const [senha, setSenha] = createSignal('')
  const [erro, setErro] = createSignal<string | null>(null)
  const [enviando, setEnviando] = createSignal(false)

  const entrar = async (ev: SubmitEvent) => {
    ev.preventDefault()
    setErro(null)
    setEnviando(true)
    try {
      props.aoEntrar(await api.auth.login(login(), senha()))
    } catch (e) {
      setErro(mensagemErro(e))
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div class="min-h-dvh flex items-center justify-center bg-page p-4">
      <form onSubmit={entrar} class="w-full max-w-sm rounded-2xl bg-panel border border-edge p-8 flex flex-col gap-4 elevated">
        <div class="flex flex-col gap-1">
          <div class="text-2xl font-semibold text-ink">
            <span class="text-accent">Werc</span> Industrial
          </div>
          <p class="text-sm text-ink-subtle">Entre com o mesmo usuário e senha do sistema Werc.</p>
        </div>
        <label class="flex flex-col gap-1.5 text-sm text-ink-muted">
          Usuário
          <Input value={login()} onInput={(e) => setLogin(e.currentTarget.value)} autocomplete="username" autofocus required />
        </label>
        <label class="flex flex-col gap-1.5 text-sm text-ink-muted">
          Senha
          <Input
            type="password"
            value={senha()}
            onInput={(e) => setSenha(e.currentTarget.value)}
            autocomplete="current-password"
            required
          />
        </label>
        <Show when={erro()}>
          <p class="text-sm text-failure" role="alert">
            {erro()}
          </p>
        </Show>
        <Button type="submit" variant="accent" disabled={enviando()}>
          {enviando() ? 'Entrando…' : 'Entrar'}
        </Button>
      </form>
    </div>
  )
}
